export const MODAL_CONFIG = { autoFocus: false, disableClose: true, maxHeight: '100vh', maxWidth: '100vw' };

export const MAX_ARRAY_LIST = 4;

export type FormArrayIcon = 'pension' | 'document' | 'study' | 'person-locked';
export type FormArrayPropertyStyle = 'bold' | 'justify-right' | 'center' | 'justify-left';
